<template>
    <section class="form-wrapper">
      <h2 class="center">{{ $t('form.heading') }}</h2>
      <p class="p center">{{ $t('form.heading2') }}</p>
      <div class="form">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input v-model="localName" type="text" class="form-control" :placeholder="$t('form.name')">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <input v-model="localEmail" type="email" class="form-control" placeholder="Email">
              <p v-if="emailError" style="color:red;">{{ $t('form.invalidEmail') }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <input v-model="localPhone" type="phone" class="form-control" :placeholder="$t('form.phone')">
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <textarea v-model="localMessage" class="form-control message" :placeholder="$t('form.message')"></textarea>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mt-4">
              <input @click="handleSubmit" type="submit" class="btn-style" :value="$t('form.send')" />
              <p v-if="error" style="color:red;">Er is iets fout gegaan, mail ons op info@merwylan.nl</p>
              <p v-if="success" style="color:green;">Bedankt! Uw aanvraag is verzonden. We nemen z.s.m. contact met u op.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  <script>
  import { computed } from 'vue'
  export default {
    name: 'ContactForm',
    props: {
      name: String,
      email: String,
      phone: String,
      message: String,
      error: Boolean,
      success: Boolean,
      emailError: Boolean,
      onSubmit: Function
    },
    setup(props, { emit }) {
      const localName = computed({
        get: () => props.name,
        set: (value) => emit('update:name', value)
      })
      const localEmail = computed({
        get: () => props.email,
        set: (value) => emit('update:email', value)
      })
      const localPhone = computed({
        get: () => props.phone,
        set: (value) => emit('update:phone', value)
      })
      const localMessage = computed({
        get: () => props.message,
        set: (value) => emit('update:message', value)
      })
      const handleSubmit = () => {
        props.onSubmit()
      }
      return {
        localName,
        localEmail,
        localPhone,
        localMessage,
        handleSubmit,
      }
    }
  }
  </script>